import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LookupWidget from "@/components/LookupWidget";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function Console() {
  const { user, loading } = useAuth();
  const nav = useNavigate();

  useEffect(() => { if (!loading && !user) nav("/login"); }, [user, loading, nav]);

  if (loading || !user) return <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-cyan-signal" /></div>;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="mb-8">
        <span className="font-mono text-xs uppercase tracking-widest text-cyan-signal">Validation Console</span>
        <h1 className="text-3xl sm:text-4xl font-display font-bold tracking-tight mt-1">Run authenticated verifications</h1>
        <p className="mt-2 text-slate-400">Each query deducts 1 credit from your balance ({user.credits?.toLocaleString()} remaining).</p>
      </div>
      <LookupWidget authed={true} defaultTab="phone" />
    </div>
  );
}
